<template>
    <div id="footer-area">

        <div class="container-fluid">


            <div class="row data-header pl-3">
                <a class="col-12 font-weight-bold">
                    おすすめのお役立ちメニュー
                </a>
            </div>

            <div class="row my-4" id="shikin-soudan">
                <div class="col-12">
                    <img class="footer-img" src="@/assets/img/result/footer/SLN_thumb_320_2122.jpg" alt="">
                    <div class="btn-wrap">
                        <p class="list-title">資金相談</p>
                        <div class="d-inline-block">
                            <a href="https://www.misawa.co.jp/homelounge/library/homeclub/special/post-559.php" class="roundButton--detail roundButton" target="_blank" style="margin-right: 10px;">
                                <span class="roundButton__text">詳細を見る</span>
                                <svg class="roundButton__arrow" xmlns="http://www.w3.org/2000/svg" width="31.414" height="19.414" viewBox="0 0 31.414 19.414">
                                    <path d="M0,0H30V2H0Z" transform="translate(0 8)" fill="currentColor"></path>
                                    <path d="M-6004.293,2882.707l-1.414-1.414,8.293-8.293-8.293-8.293,1.414-1.414,9.707,9.707Z" transform="translate(6026 -2864)" fill="currentColor"></path>
                                </svg>
                            </a>
                            <a href="https://www.misawa.co.jp/jsp/form/mk/sumai/index.jsp" class="roundButton--detail roundButton long" target="_blank">
                                <span class="roundButton__text">資金相談を申し込む</span>
                                <svg class="roundButton__arrow" xmlns="http://www.w3.org/2000/svg" width="31.414" height="19.414" viewBox="0 0 31.414 19.414">
                                    <path d="M0,0H30V2H0Z" transform="translate(0 8)" fill="currentColor"></path>
                                    <path d="M-6004.293,2882.707l-1.414-1.414,8.293-8.293-8.293-8.293,1.414-1.414,9.707,9.707Z" transform="translate(6026 -2864)" fill="currentColor"></path>
                                </svg>
                            </a>
                        </div>
                        <p class="btn-description">より詳細なライフシミュレーションをご希望の方には、当社担当者よりご説明させていただきます。</p>
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-12">
                    <img class="footer-img" src="@/assets/img/result/footer/SLN_thumb_320_212.jpg" alt="">
                    <div class="btn-wrap">
                        <p class="list-title">MISAWA HOME LOUNGE</p>
                        <a href="https://www.misawa.co.jp/homelounge/" class="roundButton--detail roundButton" target="_blank">
                            <span class="roundButton__text">詳細を見る</span>
                            <svg class="roundButton__arrow" xmlns="http://www.w3.org/2000/svg" width="31.414" height="19.414" viewBox="0 0 31.414 19.414">
                                <path d="M0,0H30V2H0Z" transform="translate(0 8)" fill="currentColor"></path>
                                <path d="M-6004.293,2882.707l-1.414-1.414,8.293-8.293-8.293-8.293,1.414-1.414,9.707,9.707Z" transform="translate(6026 -2864)" fill="currentColor"></path>
                            </svg>
                        </a>
                        <p class="btn-description">会員制サイト『ミサワホームラウンジ』では、住まいの資金計画における注意点を、分かりやすく解説しています。ぜひご登録ください。</p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <img class="footer-img" src="@/assets/img/result/footer/SLN_thumb_320_2123.jpg" alt="">
                    <div class="btn-wrap">
                        <p class="list-title">カタログ請求</p>
                        <a href="https://www.misawa.co.jp/jsp/scrform/catalog/kodate/index.jsp" class="roundButton--detail roundButton long" target="_blank">
                            <span class="roundButton__text">カタログ選択画面へ</span>
                            <svg class="roundButton__arrow" xmlns="http://www.w3.org/2000/svg" width="31.414" height="19.414" viewBox="0 0 31.414 19.414">
                                <path d="M0,0H30V2H0Z" transform="translate(0 8)" fill="currentColor"></path>
                                <path d="M-6004.293,2882.707l-1.414-1.414,8.293-8.293-8.293-8.293,1.414-1.414,9.707,9.707Z" transform="translate(6026 -2864)" fill="currentColor"></path>
                            </svg>
                        </a>
                        <p class="btn-description">ミサワホームの特徴や、住まいづくりの計画に役立つ各種カタログをご用意しています。</p>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

export default {
    name: "Footer.vue",
}
</script>

<style scoped lang="scss">

#footer-area {
    margin-bottom: 60px;

    p {
        margin-bottom: 5px;
    }

    .row {

        &.data-header {
            background: linear-gradient(to bottom, rgb(0 45 89 / 19%), #FFF) !important;

            padding-top: 8px;

            a {
                font-size: 18px;
                text-decoration: none;
                color: #000000;
            }

        }

        .col, .col-12 {
            //padding: 10px;

            .footer-img {
                width: 120px;
                float: left;
                margin-left: 10px;
                margin-right: 15px;
                margin-top: 5px;
            }

            .btn-wrap {
                padding-left: 145px;
                padding-right: 15px;

                a {
                    text-decoration: none;
                }
                .list-title {
                    display: inline-block;
                    min-width: 140px;
                    margin-right: 20px;

                    color: #586166;
                    font-weight: 700;
                    font-size: 19px;
                }

                .roundButton--detail {
                    display: inline-block;
                    position: relative;
                    top: -2px;

                    margin-bottom: 5px;

                    border: 1px solid;
                    color: #586166;
                    background-color: #fff;

                    font-size: 0.9rem;

                    width: 150px;
                    height: 27px;
                    line-height: 27px;
                    padding-left: 22px;

                    &.long {
                        width: 195px;
                    }

                    &:hover {
                        background-color: #586166;
                        color: #fff;
                    }

                    .roundButton__arrow {
                        margin-left: 5px;
                        width: 20px;
                    }
                }
                .roundButton {
                    border-radius: 40px;
                    transition: all .3s cubic-bezier(.215,.61,.355,1);
                }

                .btn-description {
                    font-size: 14px;
                    //margin-top: 5px;
                    margin-bottom: 8px;
                }

                .footer-btn {
                    background-color: #1A3383;
                    border: solid 4px #ffffff;
                    border-radius: 8px;
                    width: 100%;
                    font-weight: bold;

                }

            }

        }

    }


}

@media screen and (max-width: 768px) {
    #footer-area {
        margin-bottom: 20px;
        
        .footer-btn {
            //margin: 0px 20px;
        }
    }
}

@media screen and (max-width: 500px) {

    #footer-area .row .col-12, #footer-area .row .col {
        .footer-img {
            width: 90%;
            margin-bottom: 10px;
        }
        .btn-wrap {
            padding-left: 15px;
        }
    }

}

</style>